import { Outlet } from "react-router-dom";
import Header from "@layout/dashboard/Header";
import SideNavBar from "@layout/dashboard/SideNavBar";
import { Guard } from "@auth/Guard";
import React, { useState, useEffect } from "react";
const DashboardLayout = () => {
  // const [width, setWidth] = useState(window.innerWidth);
  var profile = Guard();
  const themeOption = {
    dark: {
      color: "#2D2D30",
      nav: "bg-dark text-white",
      inpuSearch: "bg-dark text-white",
      text: "text-white",
    },
    light: {
      color: "#F7F9FB",
      nav: "border bg-white text-dark",
      inpuSearch: "bg-white text-dark",
      text: "text-dark",
    },
  };
  const theme = themeOption[profile.mode];

  const outletContextValue = {
    profile,
    theme,
  };
  // useEffect(() => {
  //   const handleResize = () => setWidth(window.innerWidth - 500);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  return (
    <div
      className="app-layout"
      style={{ background: theme.color }}
      id="app-layout"
    >
      <div class="pageWrap">
        <div class="page">
          <div class="aside">
            <div class="sidebar">
              <div class="sidebarBody">
                <SideNavBar profile={profile} theme={theme} />
              </div>
            </div>
          </div>
          <div class="mainWrap">
            <div class="mainSection">
              <div class="header">
                <div class="flex-container px-0">
                  <Header profile={profile} theme={theme} />
                </div>
              </div>
              <div class="main">
                <div className="mainContent">
                  <Outlet context={outletContextValue} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // return (
  //   <div style={{ background: theme.color }} className="d-flex w-100">
  //     <SideNavBar profile={profile} theme={theme} />
  //     <div className="w-container">
  //       <Header profile={profile} theme={theme} />
  //       <div className="mt-3">
  //         <Outlet context={outletContextValue} />
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default DashboardLayout;
